package com.clany.backoffice.model

import kotlinx.serialization.Serializable

@Serializable
data class AccountUserResponse(
    val user: UserResponse,
    val role: String
)
